<template>
  <router-view/>
</template>

<style>
#app {
  text-align: center;
  color: #2c3e50;
  background-color: #fff;
  overflow-x: hidden;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
